"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDynamicContentPlugin = isDynamicContentPlugin;
function isDynamicContentPlugin(plugin) {
    return plugin.refresh !== undefined;
}
